let urlIsChanging = false;
import { dxEnvUrlMap } from 'config/common';
import { apiHost } from "config/env.conf";
export const redirectToNeiXin = function(userInfo) {
    if (userInfo && userInfo.userId && !urlIsChanging) {
        let referrerUrl = '';
        let href = document.location.href;
        if (href.includes(dxEnvUrlMap[ENV])) {
            referrerUrl = document.location.href;
            let urlReg = /[?&]redirect_uri=(.+?)(&|$|#)/;
            let matchArr = urlReg.exec(referrerUrl);
            if (matchArr && matchArr[1]) {
                referrerUrl = matchArr[1];
            }
        }
        if (referrerUrl && referrerUrl.length) {
            let redirectUrl = `${apiHost}/rimet/out/xmAuth/redirect?feclient=lvyou_web`;
            redirectUrl += '&redirectUrl=' + (referrerUrl.includes('/') ? encodeURIComponent(referrerUrl) : referrerUrl);
            location.href = redirectUrl;
            urlIsChanging = true;
            return true;
        }
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/utils/neixin.js